export const CLINIC_MIGRATION_BANNER_TRANSLATIONS = {
  resumeCta: {
    "pt-BR": "Continuar migração para Clínica",
    en: "Continue Clinic migration",
    es: "Continuar migración a Clínica",
    de: "Klinikmigration fortsetzen",
  },
  startCta: {
    "pt-BR": "Migrar para o Clínica",
    en: "Migrate to Clinic",
    es: "Migrar al plan Clínica",
    de: "Zur Klinik migrieren",
  },
  resumeBody: {
    "pt-BR":
      "Você iniciou a configuração da organização. Conclua a migração para acessar a Gestão Clínica.",
    en: "You started organization setup. Finish migration to access Clinic management.",
    es: "Iniciaste la configuración de la organización. Completa la migración para acceder a Gestión Clínica.",
    de: "Sie haben mit der Organisationseinrichtung begonnen. Schließen Sie die Migration ab, um auf die Klinikverwaltung zuzugreifen.",
  },
  startBody: {
    "pt-BR":
      "Tem equipe ou consultório compartilhado? Migre seus pacientes para o plano Clínica em um fluxo guiado — opcional.",
    en: "Have a team or shared practice? Migrate your patients to the Clinic plan in a guided flow — optional.",
    es: "¿Tienes equipo o consultorio compartido? Migra tus pacientes al plan Clínica en un flujo guiado — opcional.",
    de: "Haben Sie ein Team oder eine gemeinsame Praxis? Migrieren Sie Ihre Patienten in einem geführten Ablauf zum Klinikplan – optional.",
  },
  dismissAria: {
    "pt-BR": "Dispensar aviso",
    en: "Dismiss notice",
    es: "Descartar aviso",
    de: "Kündigung abweisen",
  },
} as const;
